import React from 'react';
import PropTypes from 'prop-types';
import './GridInputControls.css';

const GridInputControls = (props) => {
  let options = (props.options) ? 
    props.options.map((option) =>
      <span
        key={option.label}
        onClick={option.onClick}
      >
        {option.label}
      </span>
    ) : 
    null;

  return (
    <div className="grid-input__controls">
      {options}
    </div>
  );
}

GridInputControls.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
  }))
}

export { GridInputControls };